import { Container } from './styles';

const Login = () => {
  return <Container></Container>;
};

export default Login;
